<template>
  <v-select class="tmc-fy-select"
    id="tmcFySelect"
    :value="value"
    @change="val => changed(val)"
    :items="sortedFyRange"
    item-text="name"
    item-value="year"
    :label="`By FY`"
  ></v-select>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      required: false, // required to v-bind it
    },
    fyRange: {
      type: Array,
      default: () => [{ range: {}, year: 0, name: '(all years)' }],
    },
  },
  computed: {
    sortedFyRange() {
      return [...this.fyRange].sort((a, b) => {
        if (a.year === 0) return -1;
        if (b.year === 0) return 1;
        return b.year - a.year;
      });
    },
  },
  methods: {
    changed(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>
